import classnames from "classnames";
import React from "react";
import styles from "./style.module.css";

export default React.memo(({ className,vehicleType,  ...props }) =>
  <div
    className={classnames(className, {
      [styles.vehicleLogo]: true,
      [styles.minivan]: vehicleType === "MINIVAN",
      [styles.luxury]: vehicleType === "LUXURY_SEDAN",
      [styles.suv]: vehicleType === "SUV",
      [styles.wc]: vehicleType === "WC",
      [styles.sedan]: vehicleType === "SEDAN",
    })}
    {...props}
  />,
);
